'use client';

import type { ArticleTag } from '@/types';
import { useRouter } from 'next/navigation';
import styles from './ArticleTagList.module.scss';

function ArticleTagList({ tags }: { tags: Array<ArticleTag> }) {
  const router = useRouter();
  const handleClick = (e: React.MouseEvent, tag: ArticleTag) => {
    e.preventDefault();
    router.push(`/informations?tag=${tag.id}`);
  };
  return (
    <ul className={styles.componentStyle}>
      {tags.map((tag) => (
        <li key={tag.id}>
          {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}{' '}
          <a
            className={styles.itemBlock}
            href='#'
            onClick={(e) => {
              handleClick(e, tag);
            }}
          >
            {tag.name}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default ArticleTagList;
